import { Option, CurrentUser, CurrentAcademicUser }  from '../types';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

export class AuthenticatedIdentity {
    constructor(
        public readonly token: string,
        public readonly tokenTimeoutDate: Date,
        public readonly user: CurrentUser
    ){}
}

export class TokenInfo {
    constructor(
        public readonly token: string,
        public readonly tokenTimeoutDate: Date,
    ){}
    public static fromJson(o: any): TokenInfo {
		return new TokenInfo(
			o.token,
			o.tokenTimeoutDate);
	}
}

export class Authenticated {
    constructor(
        public readonly tokenInfo: TokenInfo,
        public readonly user: CurrentUser,
        public readonly currentApplicationVersion: string
	){}
	public static fromJson(o: any): Authenticated {
		return new Authenticated(
			TokenInfo.fromJson(o.tokenInfo),
			CurrentUser.fromJson(o.user),
			o.currentApplicationVersion);
	}
}

export enum AuthenticationType {
    AzureAD = 1,
    Okta = 2
}

export interface AuthResult {
    accessToken: string;
    idToken: string;
    provider: string;
    employeeId: string;
    name: string;
    email: string;
    username: string;
}

export class AuthResultImpl implements AuthResult {
    constructor(
        public accessToken: string,
        public idToken: string,
        public provider: string,
        public employeeId: string,
        public name: string,
        public email: string,
        public username: string
    ) {}
    public static fromJson(o: any): AuthResult {
        return new AuthResultImpl(
            o.accessToken,
            o.idToken,
            o.provider,
            o.employeeId,
            o.name,
            o.email,
            o.username);
    }
}

@Injectable()
export abstract class AuthenticationService {
    public abstract get currentIdentity(): Observable<Option<AuthenticatedIdentity>>;
    public abstract get isAuthenticated(): boolean;
    public abstract accept(a: Authenticated): void;
    public abstract clearCurrentUser(): void;
    public abstract tryAuthenticate(authResult: AuthResult, authType: AuthenticationType): Promise<boolean>
    public abstract tryGetCurrentAcademicUserSync(): Option<CurrentAcademicUser>;
    public abstract tryAuthenticateViaLocalStorage(): Promise<boolean>;
}